import $ from 'jquery';

/**
 * Toggle open state for a collapsible mobile menu parent item.
 *
 * @since ??
 *
 * @param {JQuery} $parentItem Parent menu item.
 */
export const toggleCollapsibleMenuItem = ($parentItem: JQuery): void => {
  const isOpen = !$parentItem.hasClass('et_pb_collapsible_menu_open');

  $parentItem.toggleClass('et_pb_collapsible_menu_open', isOpen);
  $parentItem.children('.mobile-toggle').attr('aria-expanded', isOpen ? 'true' : 'false');
};

/**
 * Initialize collapsible mobile submenu toggles for Menu modules.
 *
 * Injects `.mobile-toggle` buttons after `et_duplicate_menu` clones the nav,
 * then toggles `.et_pb_collapsible_menu_open` + aria-expanded. Skips modules
 * currently owned by the VB collapsible preview.
 *
 * @since ??
 */
export const initCollapsibleMobileMenus = (): void => {
  $('.et_pb_menu--collapsible-mobile').each((_index, element) => {
    const $module = $(element);
    const parentLinksActive = $module.hasClass('et_pb_menu--collapsible-parent-links-active');
    const $mobileMenu = $module.find('ul.et_mobile_menu');

    // VB preview owns toggle handlers while the design group is open.
    if ($module.hasClass('et_pb_menu--collapsible-mobile-preview')) {
      return;
    }

    if (!$mobileMenu.length || $mobileMenu.data('etPbCollapsibleMenuReady')) {
      return;
    }

    $mobileMenu.data('etPbCollapsibleMenuReady', true);

    $mobileMenu.find('li.menu-item-has-children, li.page_item_has_children').each((_itemIndex, itemElement) => {
      const $parentItem = $(itemElement);

      if ($parentItem.children('.mobile-toggle').length) {
        return;
      }

      const $toggle = $(
        '<button type="button" class="mobile-toggle" aria-expanded="false" aria-label="Toggle submenu">' +
          '<span class="et_pb_menu__collapsible-icon" aria-hidden="true"></span>' +
          '</button>',
      );

      // Place toggle immediately after the link so it stays on the same
      // flex row when the submenu opens (append would drop it below).
      $parentItem.children('a').first().after($toggle);
    });

    $mobileMenu.on(
      'click.etPbCollapsibleMenu',
      'li.menu-item-has-children > .mobile-toggle, li.page_item_has_children > .mobile-toggle',
      event => {
        event.preventDefault();
        event.stopPropagation();

        toggleCollapsibleMenuItem($(event.currentTarget as HTMLElement).parent('li'));
      },
    );

    if (!parentLinksActive) {
      // Replace clone-time link handlers so parent clicks expand instead of navigating / closing the menu.
      $mobileMenu
        .find('li.menu-item-has-children > a, li.page_item_has_children > a')
        .off('click')
        .on('click.etPbCollapsibleMenu', event => {
          event.preventDefault();
          event.stopImmediatePropagation();

          toggleCollapsibleMenuItem($(event.currentTarget).parent('li'));
        });
    }
  });
};
